import React from 'react';
import CaseCard from '../components/CaseCard';
import LiveFeed from '../components/LiveFeed';
import MainBanner from '../components/MainBanner';

export default function Home({ cases }) {
  return (
    <>
      <LiveFeed isTest={true}/>
      <MainBanner />
      <div className="cases-wrapper">
        <div className="cases-grid">
          {cases.map(caseItem => (
            <CaseCard key={caseItem.id} caseItem={caseItem} />
          ))}
        </div>
      </div>
    </>
  );
}
